import BaseService from './BaseService'
import ResellingService from './ResellingService'
import { AxiosPromise } from 'axios'

const PRODUCT_CODE = 'YEXT_V2'
import config from "../config"

interface IYextAvailabilityResponse {
  offeringAllowed: boolean
  locationCountry: boolean
  availableCountries: Array<{
    label: string
    value: string
  }>,
  countryPublisherCount: number
}

class YextResellingService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }

  resellingService = new ResellingService(config.resellingBaseUrl, PRODUCT_CODE)

  getLocationConfig = (locationId: string) => this.requests.get(`/reselling/location/${locationId}`)

  getCompanyConfig = (companyId: string) => this.requests.get(`/reselling/company/${companyId}`)

  updateCompanyResellingConfig = (
    companyId: string,
    data: { amount?: number; saasOfferPlanType?: string; planLevel?: number }
  ) => this.requests.put(`/reselling/company/${companyId}`, data)

  updateLocationResellingConfig = (locationId: string, data: { amount?: number; offeringEnabled?: boolean }) =>
    this.requests.put(`/reselling/location/${locationId}`, data)

  createAgencyDirectSubscription = (locationId: string) =>
    this.requests.post(`/reselling/location/${locationId}/purchase/company-direct-purchase`, {})

  getLocationSubscriptions = (locationId: string) =>
    this.requests.get(`/reselling/location/${locationId}/subscriptions`)

  checkYextAvailable = (locationId: string): Promise<IYextAvailabilityResponse> => {
    return this.requests.get(`/available/${locationId}`)
  }

  getLocationEntities = (locationId: string) =>
    this.requests.get(`/lc-listings/${locationId}/entities`)
}

const instance = new YextResellingService(
  BaseService.servicesConfig.Yext as string
  // "http://localhost:9612/yext"
)

export default instance
